import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  mobileStepper_container: {
    height: "80px",
    width: "100%",
  },
  mobileStepper_box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },

  iconWithLabelBox: {
    // margin: '0px 25px',
    marginLeft: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // background: 'red',
    // padding: '10px',
    // minWidth: '240px',
  },

  labelOnly: {
    margin: "0px 20px",
    fontSize: "20px",
    color: "#353535",
    letterSpacing: "0",
    lineHeight: "24px",
  },
  numberWithDropDown: {
    margin: "0px 25px",
    fontSize: "18px",
    color: "#353535",
    letterSpacing: "0",
    lineHeight: "24px",
  },
  grey_span: {
    color: "#ccc",
  },
}));

export default useStyles;
